// extracted by mini-css-extract-plugin
export var statItem = "_jo-1";
export var statsRow = "_jo-0";